export const getBearerTokenStr = (token: string | null) =>
  token ? `Bearer ${token}` : '';
